let cidSeq = 0;

export const genCid = () => {
    cidSeq += 1;
    return `cid-${Date.now()}-${cidSeq}-${Math.random().toString(16).slice(2)}`;
};

export const ensureCid = (row: any) => {
    if (!row) return row;
    if (!row.id && !row.clientId) row.clientId = genCid();
    return row;
};

export const stableKey = (row: any, prefix: string) => {
    if (!row) return `${prefix}-missing`;
    if (row.id) return `${prefix}-id-${row.id}`;
    return `${prefix}-cid-${row.clientId}`;
};


export const getNextSortOrder = (fields: any): number => {
    let max = -1;
    for (let i = 0; i < fields.length; i++) {
        const so = fields.get(i)?.sortOrder ?? 0;
        if (so > max) max = so;
    }
    return max + 1;
};
